import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Button, Col, Row, Spin, Table, Typography } from "antd";
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { EUserRole } from "@devowl-wp/api-real-cookie-banner";
import { useReleaseOverViewColumns } from "./overview/columns.js";
import { ReleaseExpansion } from "./overview/release-expansion.js";
import { ReleaseModal } from "./wizard/release-modal.js";
import { useReleases } from "../../../../hooks/useReleases.js";
import { useTranslation } from "../../../../others/i18n.js";
import { useStores } from "../../../../store/root.js";
import { ForbiddenInfo } from "../../forbidden.js";
import { PermissionCheck } from "../user/permission.js";
function Releases() {
    // Generals
    const { t } = useTranslation();
    const { notificationStore, rcbAuthenticationStore } = useStores();
    // Permission Checks
    const hasRole = rcbAuthenticationStore.hasRole(EUserRole.Admin);
    if (!hasRole) {
        return /*#__PURE__*/ _jsx(ForbiddenInfo, {});
    }
    // UI elements
    const { Title } = Typography;
    const title = t("Releases");
    // Release modal
    const [isReleaseOpen, setIsReleaseOpen] = useState(false);
    // Columns
    const columns = useReleaseOverViewColumns(t);
    // Query to display all previous releases
    const releasesQuery = useReleases();
    useEffect(()=>{
        if (releasesQuery.error) {
            notificationStore.addFromServerError(releasesQuery.error, t);
        }
    }, [
        releasesQuery
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Helmet, {
                children: /*#__PURE__*/ _jsx("title", {
                    children: title
                })
            }),
            /*#__PURE__*/ _jsxs(PermissionCheck, {
                minRole: EUserRole.Admin,
                children: [
                    /*#__PURE__*/ _jsxs(Row, {
                        style: {
                            paddingBottom: "1rem"
                        },
                        children: [
                            /*#__PURE__*/ _jsx(Col, {
                                children: /*#__PURE__*/ _jsx(Title, {
                                    level: 3,
                                    children: title
                                })
                            }),
                            /*#__PURE__*/ _jsx(Col, {
                                children: /*#__PURE__*/ _jsx(Button, {
                                    type: "primary",
                                    onClick: ()=>{
                                        setIsReleaseOpen(true);
                                    },
                                    style: {
                                        float: "left",
                                        marginLeft: "1rem"
                                    },
                                    children: t("Prepare new release")
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(Row, {
                        children: /*#__PURE__*/ _jsx(Col, {
                            flex: 1,
                            children: /*#__PURE__*/ _jsx(Spin, {
                                spinning: releasesQuery.isFetching,
                                children: /*#__PURE__*/ _jsx(Table, {
                                    dataSource: releasesQuery?.data?.releases,
                                    columns: columns,
                                    pagination: false,
                                    rowKey: "id",
                                    expandable: {
                                        expandedRowRender: (record)=>/*#__PURE__*/ _jsx(ReleaseExpansion, {
                                                release: record
                                            })
                                    }
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsx(ReleaseModal, {
                        open: isReleaseOpen,
                        title: t("Draft of release {{releaseNumber}}", {
                            releaseNumber: Math.max(0, ...releasesQuery?.data?.releases?.length > 0 ? releasesQuery?.data?.releases?.map((r)=>Number(r.id)) || [
                                0
                            ] : [
                                0
                            ]) + 1
                        }),
                        onCancel: ()=>{
                            setIsReleaseOpen(false);
                        },
                        onReleased: ()=>{
                            setIsReleaseOpen(false);
                            releasesQuery.refetch();
                        }
                    })
                ]
            })
        ]
    });
}
export { Releases };
